export default __webpack_public_path__ + "static/media/icon3-m.12969a1e.png";